export default __webpack_public_path__ + "static/media/carColoringSample.504368e0dc74b422c376a1bc260499e1.png";